/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  ArmorSetsList,
  CharacterBodiesList,
  Outfit,
  OutfitCreateInput,
  OutfitUpdateInput,
  OutfitsList,
  SchemaValidationErrorResponse,
  StandardError,
  SuccessResponse,
  ValidationError
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Armor sets
 */
export const armorSets = (

 signal?: AbortSignal
) => {


      return axiosClient<ArmorSetsList>(
      {url: `/armor-sets`, method: 'GET', signal
    },
      );
    }




export const getArmorSetsQueryKey = () => {
    return [
    'armor-sets'
    ] as const;
    }


export const getArmorSetsQueryOptions = <TData = Awaited<ReturnType<typeof armorSets>>, TError = ErrorType<StandardError>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof armorSets>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getArmorSetsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof armorSets>>> = ({ signal }) => armorSets(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof armorSets>>, TError, TData>
}

export type ArmorSetsQueryResult = NonNullable<Awaited<ReturnType<typeof armorSets>>>
export type ArmorSetsQueryError = ErrorType<StandardError>


/**
 * @summary Armor sets
 */

export function useArmorSets<TData = Awaited<ReturnType<typeof armorSets>>, TError = ErrorType<StandardError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof armorSets>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getArmorSetsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Character bodies
 */
export const characterBodies = (

 signal?: AbortSignal
) => {


      return axiosClient<CharacterBodiesList>(
      {url: `/character-bodies`, method: 'GET', signal
    },
      );
    }




export const getCharacterBodiesQueryKey = () => {
    return [
    'character-bodies'
    ] as const;
    }


export const getCharacterBodiesQueryOptions = <TData = Awaited<ReturnType<typeof characterBodies>>, TError = ErrorType<StandardError>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof characterBodies>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getCharacterBodiesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof characterBodies>>> = ({ signal }) => characterBodies(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof characterBodies>>, TError, TData>
}

export type CharacterBodiesQueryResult = NonNullable<Awaited<ReturnType<typeof characterBodies>>>
export type CharacterBodiesQueryError = ErrorType<StandardError>


/**
 * @summary Character bodies
 */

export function useCharacterBodies<TData = Awaited<ReturnType<typeof characterBodies>>, TError = ErrorType<StandardError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof characterBodies>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCharacterBodiesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Outfits
 */
export const outfits = (

 signal?: AbortSignal
) => {


      return axiosClient<OutfitsList>(
      {url: `/outfits`, method: 'GET', signal
    },
      );
    }




export const getOutfitsQueryKey = () => {
    return [
    'outfits'
    ] as const;
    }


export const getOutfitsQueryOptions = <TData = Awaited<ReturnType<typeof outfits>>, TError = ErrorType<StandardError>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof outfits>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getOutfitsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof outfits>>> = ({ signal }) => outfits(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof outfits>>, TError, TData>
}

export type OutfitsQueryResult = NonNullable<Awaited<ReturnType<typeof outfits>>>
export type OutfitsQueryError = ErrorType<StandardError>


/**
 * @summary Outfits
 */

export function useOutfits<TData = Awaited<ReturnType<typeof outfits>>, TError = ErrorType<StandardError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof outfits>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOutfitsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Create Outfit
 */
export const createOutfit = (
    outfitCreateInput: MaybeRefOrGetter<OutfitCreateInput>,
 signal?: AbortSignal
) => {
      outfitCreateInput = toValue(outfitCreateInput);

      return axiosClient<Outfit>(
      {url: `/outfits`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: outfitCreateInput, signal
    },
      );
    }




export const getCreateOutfitMutationKey = () => ['createOutfit'] as const;

export const getCreateOutfitMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOutfit>>, TError,CreateOutfitMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createOutfit>>, TError,CreateOutfitMutationVariables, TContext> => {

const mutationKey = getCreateOutfitMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createOutfit>>, CreateOutfitMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createOutfit(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateOutfitMutationResult = NonNullable<Awaited<ReturnType<typeof createOutfit>>>
    export type CreateOutfitMutationBody = OutfitCreateInput
    export type CreateOutfitMutationError = ErrorType<ValidationError | StandardError>
    export type CreateOutfitMutationVariables = {data: OutfitCreateInput}

    /**
 * @summary Create Outfit
 */
export const useCreateOutfit = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOutfit>>, TError,CreateOutfitMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createOutfit>>,
        TError,
        CreateOutfitMutationVariables,
        TContext
      > => {
      return useMutation(getCreateOutfitMutationOptions(options), queryClient);
    }
    /**
 * @summary Outfit
 */
export const outfit = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<Outfit>(
      {url: `/outfits/${id}`, method: 'GET', signal
    },
      );
    }




export const getOutfitQueryKey = (id: MaybeRefOrGetter<string>,) => {
    return [
    'outfits',id
    ] as const;
    }


export const getOutfitQueryOptions = <TData = Awaited<ReturnType<typeof outfit>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof outfit>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getOutfitQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof outfit>>> = ({ signal }) => outfit(id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof outfit>>, TError, TData>
}

export type OutfitQueryResult = NonNullable<Awaited<ReturnType<typeof outfit>>>
export type OutfitQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Outfit
 */

export function useOutfit<TData = Awaited<ReturnType<typeof outfit>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof outfit>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOutfitQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update Outfit
 */
export const updateOutfit = (
    id: MaybeRefOrGetter<string>,
    outfitUpdateInput: MaybeRefOrGetter<OutfitUpdateInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
outfitUpdateInput = toValue(outfitUpdateInput);

      return axiosClient<Outfit>(
      {url: `/outfits/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: outfitUpdateInput, signal
    },
      );
    }




export const getUpdateOutfitMutationKey = () => ['updateOutfit'] as const;

export const getUpdateOutfitMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOutfit>>, TError,UpdateOutfitMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateOutfit>>, TError,UpdateOutfitMutationVariables, TContext> => {

const mutationKey = getUpdateOutfitMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateOutfit>>, UpdateOutfitMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateOutfit(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateOutfitMutationResult = NonNullable<Awaited<ReturnType<typeof updateOutfit>>>
    export type UpdateOutfitMutationBody = OutfitUpdateInput
    export type UpdateOutfitMutationError = ErrorType<ValidationError | StandardError>
    export type UpdateOutfitMutationVariables = {id: string;data: OutfitUpdateInput}

    /**
 * @summary Update Outfit
 */
export const useUpdateOutfit = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOutfit>>, TError,UpdateOutfitMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateOutfit>>,
        TError,
        UpdateOutfitMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateOutfitMutationOptions(options), queryClient);
    }
    /**
 * @summary Destroy Outfit
 */
export const destroyOutfit = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<SuccessResponse>(
      {url: `/outfits/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyOutfitMutationKey = () => ['destroyOutfit'] as const;

export const getDestroyOutfitMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyOutfit>>, TError,DestroyOutfitMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyOutfit>>, TError,DestroyOutfitMutationVariables, TContext> => {

const mutationKey = getDestroyOutfitMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyOutfit>>, DestroyOutfitMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  destroyOutfit(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyOutfitMutationResult = NonNullable<Awaited<ReturnType<typeof destroyOutfit>>>

    export type DestroyOutfitMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type DestroyOutfitMutationVariables = {id: string}

    /**
 * @summary Destroy Outfit
 */
export const useDestroyOutfit = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyOutfit>>, TError,DestroyOutfitMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyOutfit>>,
        TError,
        DestroyOutfitMutationVariables,
        TContext
      > => {
      return useMutation(getDestroyOutfitMutationOptions(options), queryClient);
    }
